import { render, staticRenderFns } from "./assetDatabase.vue?vue&type=template&id=de12b6d6&scoped=true"
import script from "./assetDatabase.vue?vue&type=script&lang=js"
export * from "./assetDatabase.vue?vue&type=script&lang=js"
import style0 from "./assetDatabase.vue?vue&type=style&index=0&id=de12b6d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de12b6d6",
  null
  
)

export default component.exports